module.exports = __webpack_public_path__ + "img/graphics-4.c550e5d0.svg";